import React from 'react';

const Login: React.FC = () => {

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 'calc(100vh - 64px)',
        padding: '2rem',
        background: '#f8f9fa',
      }}
    >
      <div
        style={{
          maxWidth: 600,
          width: '100%',
          padding: '3rem',
          background: 'white',
          borderRadius: 8,
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          textAlign: 'center',
        }}
      >
        <h1 style={{
          fontSize: '2.5rem',
          fontWeight: 700,
          color: '#333',
          marginBottom: '1rem'
        }}>
          Welcome to the Address Analytics Portal
        </h1>
        <p style={{
          fontSize: '1.1rem',
          color: '#666',
          lineHeight: '1.6',
          marginBottom: '2rem'
        }}>
          Explore detailed insights about addresses, track validation feedback, and manage customer data.
        </p>
        <p style={{
          fontSize: '0.95rem',
          color: '#999',
          fontStyle: 'italic'
        }}>
          Please use the "Sign In with Zitadel" button in the navigation bar to access the portal.
        </p>
      </div>
    </div>
  );
};

export default Login;
